import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-30c46f86"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "sidebar-container" };
var _hoisted_2 = { class: "flex-1 overflow-auto" };
var _hoisted_3 = { class: "color-white text-center fs-12 mb-2" };
import MenuBar from '@/layout/components/sidebar/menu-bar/MenuBar.vue';
import { onMounted } from 'vue';
import { useStore } from 'vuex';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SideBar',
    setup: function (__props) {
        var sotre = useStore();
        var projectInfo = sotre.getters['app/projectInfo'];
        onMounted(function () {
            // --
        });
        return function (_ctx, _cache) {
            var _component_el_scrollbar = _resolveComponent("el-scrollbar");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_el_scrollbar, { always: "" }, {
                        default: _withCtx(function () { return [
                            _createVNode(MenuBar)
                        ]; }),
                        _: 1
                    })
                ]),
                _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(projectInfo).company), 1)
            ]));
        };
    }
});
